<div class="dynamic-popover-container">
<div class="text">
  {{text}}
</div>
<img [copyToClipboard]="text"  src="../../../../assets/images/icons/copy-icon.svg" alt="">
</div>